<!--
@component
This component displays a single image with a caption and credit. Size defaults to 'narrow' but can be set to 'wide' or 'full' by passing the prop 'size' to the component.
@prop {string} url - URL of the image.
@prop {string} size - Default is 'narrow'. Can be set to 'wide' or 'full'.
@prop {string} caption - Center-aligned caption text.
@prop {string} credit - Credit text that follows the caption.

# Block
Type: SingleImage
url: https://gdb.rferl.org/01000000-0aff-0242-d47b-08db965329b0.jpg
size: wide
caption: A trident has already been installed instead of the Soviet coat of arms on the shield of the "Motherland-mother" monument, which is to be renamed "Ukraine-mother".
credit: Serhii Nuzhnenko/RadioSvoboda.org
-->
<script lang="ts">
	// IMPORTS
	import Block from '$components/Block/Block.svelte';
	import Image from '$components/Image/Image.svelte';
	import { gsap, ScrollTrigger } from '$utils/gsap.svelte.js';

	// PROPS
	export let url: string;
	export let thumbhash: ArrayLike<number>;
	export let caption: string;
	export let credit: string;

	// LOGIC
	function revealImage(el: HTMLElement) {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'bottom+=40% 100%',
				toggleActions: 'play none none none',
			},
		});

		tl.fromTo(el, { opacity: 0 }, { opacity: 1, duration: 1 });
	}
</script>

<Block let:width="{columnWidth}">
	<figure class="SingleImage" use:revealImage>
		<Image {url} {thumbhash} alt="{caption}" {columnWidth} />
		<figcaption>{caption}<span class="credit">({credit})</span></figcaption>
	</figure>
</Block>

<style lang="scss">
	.SingleImage {
		position: relative;
		z-index: 0;
	}

	figcaption {
		color: #9e8c7b;
	}
</style>
